<template>
  <div>
    <b-navbar toggleable="lg" type="dark" class="navBar">
      <b-navbar-brand href="#">
        <img src="../../assets/APP_logo.jpg" class="nav-logo" />
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <router-link tag="b-nav-item" to="/">Home</router-link>
          <router-link tag="b-nav-item" to="/clientes">Clientes</router-link>
          <router-link tag="b-nav-item" to="/percursos">Percursos</router-link>
          <router-link tag="b-nav-item" to="/eventos">Eventos</router-link>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template slot="button-content">
              <em>Admin</em>
            </template>
            <b-dropdown-item href="#" @click="logout()">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import router, { Auth } from "../../router";
export default {
  name: "navBar",
  data() {
    return {};
  },
  methods: {
    logout: function() {
      Auth.logout();
      router.push("/");
    }
  }
};
</script>

<style lang='css'>
.navBar {
  background-color: #53554c !important;
  width: 100%;
}
.nav-logo {
  width: 50px;
}
</style>
